import { store } from '@/decorators/store';
import { UnassignReasons } from '@/entities/UnassignReasons';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'UnassignReasons' })
export class UnassignReasonsStore extends AbstractEntityStore<UnassignReasons> {
  protected entityIdKey = 'id';
  protected entityLabelKey = 'value';
  protected entityValueKey = 'value';
}
